// src/index.tsx
import { createRoot } from 'react-dom/client';
import React, { StrictMode } from 'react';
import App from './App';
import './index.css';
import './global.css';

// Stili Mantine
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';

// Stili globali personalizzati Ginori
import './styles/global.css';

// Locale dayjs per i componenti data (DatePickerInput locale="it", ecc.)
import 'dayjs/locale/it';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);